import { useTranslation } from 'react-i18next'

import { RadioGroupModal } from '../../Radio'
import {
  CHATROOM_INPUT_FIELD_NAME_INSERT_REPLACE,
  CHATROOM_INPUT_TEMPLATE_CONFIRMATION_INITIAL_VALUES,
} from '../Chatroom.constants'

import { getChatroomInputTemplateConfirmationOptions } from './ChatroomInputTemplateConfirmationModal.utils'

function ChatroomInputTemplateConfirmationModal(props) {
  const { t } = useTranslation()

  function getOptions() {
    return getChatroomInputTemplateConfirmationOptions({ t })
  }

  return (
    <RadioGroupModal
      {...props}
      formFieldsProps={{
        getOptions,
        name: CHATROOM_INPUT_FIELD_NAME_INSERT_REPLACE,
        title: t('Chatroom.TemplateConfirmationModalTextKey'),
      }}
      initialValues={CHATROOM_INPUT_TEMPLATE_CONFIRMATION_INITIAL_VALUES}
      title={t('Chatroom.TemplateConfirmationModalTitleKey')}
    />
  )
}

export default ChatroomInputTemplateConfirmationModal
